import { render, staticRenderFns } from "./TodoWork.vue?vue&type=template&id=0a7d589a&scoped=true"
import script from "./TodoWork.vue?vue&type=script&lang=js"
export * from "./TodoWork.vue?vue&type=script&lang=js"
import style0 from "./TodoWork.vue?vue&type=style&index=0&id=0a7d589a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7d589a",
  null
  
)

export default component.exports